import { Link } from "react-router-dom";
import Seo from "@/components/seo/Seo";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Not Found — Adeshi Moffi | Investors Pathway"
        description="The page you're looking for could not be found."
        path="/leadership/not-found"
      />
      <section className="pt-40 pb-24 min-h-[70vh]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
          <div className="section-num text-[#8E7331]">404</div>
          <h1 className="h-display text-6xl md:text-8xl text-[#0A1128] mt-6">
            Page not found.
          </h1>
          <p className="mt-6 body-lead max-w-xl">
            The page you requested is no longer available. Please return to the
            Office of the President.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/leadership" data-testid="notfound-home" className="btn-ink">Return to Leadership</Link>
            <Link to="/leadership/contact" data-testid="notfound-contact" className="btn-outline">Contact the Office</Link>
          </div>
        </div>
      </section>
    </>
  );
}
